document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".product-details product-price")
    .forEach(function (price) {
      price.classList.add("price-ready");
    });
});

document.addEventListener("DOMContentLoaded", function () {
  function syncSubscriptionProductCardPrices(scope = document) {
    const detailsBlocks = [];

    if (
      scope instanceof Element &&
      scope.matches(".card_product_details_block")
    ) {
      detailsBlocks.push(scope);
    }

    if (scope.querySelectorAll) {
      detailsBlocks.push(
        ...scope.querySelectorAll(".card_product_details_block"),
      );
    }

    detailsBlocks.forEach((detailsBlock) => {
      const priceTemplate = detailsBlock.querySelector(
        "template[data-product-card-subscription-price]",
      );
      const priceContainer = detailsBlock.querySelector(
        'product-price [ref="priceContainer"]',
      );
      const subscriptionPriceContainer =
        priceTemplate?.content.firstElementChild;

      if (!priceTemplate || !priceContainer || !subscriptionPriceContainer)
        return;

      const subscriptionMarkup = subscriptionPriceContainer.innerHTML.trim();
      if (priceContainer.innerHTML.trim() !== subscriptionMarkup) {
        priceContainer.innerHTML = subscriptionMarkup;
      }
    });
  }

  syncSubscriptionProductCardPrices();

  const productCardSubscriptionObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) syncSubscriptionProductCardPrices(node);
      });
    });
  });
  productCardSubscriptionObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Init Swiper slider
  document.querySelectorAll(".heroSwiper").forEach((heroElement) => {
    new Swiper(heroElement, {
      loop: true,
      speed: 800,
      autoplay: { delay: 4000 },
      navigation: {
        nextEl: heroElement.querySelector(".swiper-button-next"),
        prevEl: heroElement.querySelector(".swiper-button-prev"),
      },
    });
  });

  // Add animation class on load
  document.querySelectorAll(".animate-on-load").forEach(function (el) {
    el.classList.add("start-animation");
  });

  /** @type {{ button: Element, formComponent: Element, timeoutId: number } | null} */
  let pendingProductCardAdd = null;

  function resetProductCardAddLoading() {
    if (!pendingProductCardAdd) return;

    window.clearTimeout(pendingProductCardAdd.timeoutId);
    pendingProductCardAdd.button.classList.remove("icon-button_--loading");
    pendingProductCardAdd.button.removeAttribute("aria-busy");
    pendingProductCardAdd = null;
  }

  function openCartDrawerAfterMorph(attempt = 0) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const cartDrawer = document.querySelector("cart-drawer-component");

        if (cartDrawer && typeof cartDrawer.open === "function") {
          cartDrawer.open();

          requestAnimationFrame(() => {
            const dialog = cartDrawer.querySelector("dialog");
            if (!dialog?.open && attempt < 8) {
              window.setTimeout(
                () => openCartDrawerAfterMorph(attempt + 1),
                100,
              );
            }
          });
          return;
        }

        if (attempt < 8) {
          window.setTimeout(() => openCartDrawerAfterMorph(attempt + 1), 100);
        }
      });
    });
  }

  document.addEventListener("cart:update", function (event) {
    if (!pendingProductCardAdd) return;
    if (event.target !== pendingProductCardAdd.formComponent) return;

    resetProductCardAddLoading();

    if (event.detail?.data?.didError) return;

    openCartDrawerAfterMorph();
  });

  document.addEventListener("cart:error", function (event) {
    if (!pendingProductCardAdd) return;
    if (event.target !== pendingProductCardAdd.formComponent) return;
    resetProductCardAddLoading();
  });

  document.addEventListener(
    "click",
    function (e) {
      const button = e.target.closest(".icon-button_");
      if (
        !button ||
        button.classList.contains("icon-button_--disabled") ||
        button.classList.contains("icon-button_--loading")
      ) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      const wrapper = button.closest(".product-card-icon-button");
      const formComponent = wrapper?.querySelector("product-form-component");
      const form = formComponent?.querySelector("form");
      const submitBtn = form?.querySelector(
        'button[type="submit"].add-to-cart-button',
      );

      if (!form || !submitBtn || submitBtn.disabled) return;

      resetProductCardAddLoading();

      button.classList.add("icon-button_--loading");
      button.setAttribute("aria-busy", "true");

      const timeoutId = window.setTimeout(resetProductCardAddLoading, 15000);

      pendingProductCardAdd = { button, formComponent, timeoutId };

      form.requestSubmit(submitBtn);
    },
    true,
  );

  const items = document.querySelectorAll(
    ".overflow-menu li.menu-list__list-item",
  );
  items.forEach((item) => {
    item.addEventListener("mouseover", () => {
      const link = item.querySelector("a");
      if (!link) return;
      // check aria-expanded attribute
      var text = link.querySelector(".menu-list__link-title").innerHTML.trim();
      const isExpanded = link.getAttribute("aria-expanded") === "true";
      //console.log("Hovered item:", item, "Expanded:", isExpanded);
      // Example action:
      if (isExpanded) {
        if (text == "Shop All") {
          document.querySelector(
            "#header-component .header__row",
          ).style.borderRadius = "18px 18px 0 0";
        }
      } else {
        document.querySelector(
          "#header-component .header__row",
        ).style.borderRadius = "18px 18px 18px 18px";
      }
    });
  });
  /*******/

  const swiper = new Swiper(".mega_menue_swiper", {
    slidesPerView: 5,
    spaceBetween: 20,
    speed: 600,
    loop: true,
    grabCursor: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
      },
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 4,
      },
      1400: {
        slidesPerView: 5,
      },
    },
  });
  /********/

  document.addEventListener("click", function (e) {
    const trigger = e.target.closest(".mega-cat-accordion__trigger");
    if (!trigger) return; // not clicking on accordion header

    const item = trigger.closest(".mega-cat-accordion__item");
    const panelId = trigger.dataset.target;
    const panel = document.getElementById(panelId);
    if (!item || !panel) return;

    const accordion = item.closest(".mega-cat-accordion");
    const allItems = accordion.querySelectorAll(".mega-cat-accordion__item");

    const isOpen = item.classList.contains("is-open");

    // Close all items
    allItems.forEach((it) => {
      it.classList.remove("is-open");

      const t = it.querySelector(".mega-cat-accordion__trigger");
      const pid = t.dataset.target;
      const p = document.getElementById(pid);

      if (p) p.style.display = "none";
      t.setAttribute("aria-expanded", "false");

      const plus = it.querySelector(".icon-plus");
      const minus = it.querySelector(".icon-minus");
      if (plus) plus.style.display = "inline";
      if (minus) minus.style.display = "none";
    });

    // Open clicked item if it was closed
    if (!isOpen) {
      item.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
      panel.style.display = "block";

      const plus = item.querySelector(".icon-plus");
      const minus = item.querySelector(".icon-minus");
      if (plus) plus.style.display = "none";
      if (minus) minus.style.display = "inline";
    }
  });

  // Click "Key Ingredients" inside .details-content and smooth-scroll to #ingredient
  document.addEventListener("click", (e) => {
    const strong = e.target.closest(".details-content span strong");
    if (!strong) return;
    const cleaned = (strong.textContent || "").replace(/\s+/g, " ").trim();
    strong.textContent = cleaned;
    if (cleaned.toLowerCase() === "key ingredients") {
      e.preventDefault();
      const ingredientEl = document.querySelector("#ingredient");
      if (ingredientEl) {
        ingredientEl.scrollIntoView({ behavior: "smooth", block: "start" });
        // optional: update hash
        // history.replaceState(null, "", "#ingredient");
      }
    }
  });

  document.addEventListener("click", function (e) {
    const reviewParagraph = e.target.closest(".product_reviews_detail p");
    if (!reviewParagraph) return;
    const ingredientEl = document.querySelector(".okendo_widget");
    if (!ingredientEl) return;
    ingredientEl.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  });

  /*********/

  document.querySelectorAll(".ingredient-description").forEach((desc) => {
    const fullText = desc.dataset.fullText;
    const words = fullText.split(/\s+/);

    if (words.length <= 30) return;

    const first30 = words.slice(0, 30).join(" ");
    const rest = words.slice(30).join(" ");

    const dots = desc.querySelector(".dots");
    const moreText = desc.querySelector(".more-text");
    const toggle = desc.querySelector(".toggle-more");

    moreText.textContent = " " + rest;

    toggle.addEventListener("click", (e) => {
      e.preventDefault();

      const expanded = toggle.textContent === "Show less";

      if (expanded) {
        // collapse
        moreText.style.display = "none";
        dots.style.display = "inline";
        toggle.textContent = "Show more";
        desc.firstChild.textContent = first30;
      } else {
        // expand
        moreText.style.display = "inline";
        dots.style.display = "none";
        toggle.textContent = "Show less";
      }
    });
  });
});

/** Mobile menu drawer: portal to body so sticky header stacking can't steal taps. */
(function () {
  function restoreDrawer(details) {
    const drawer = document.querySelector(".menu-drawer.menu-drawer--ported");
    const backdrop = document.querySelector(
      ".menu-drawer__backdrop.menu-drawer__backdrop--ported",
    );
    if (drawer) {
      drawer.classList.remove("menu-drawer--ported");
      details.appendChild(drawer);
    }
    if (backdrop) {
      backdrop.classList.remove("menu-drawer__backdrop--ported");
      details.appendChild(backdrop);
    }
  }

  function portalDrawer(details) {
    const drawer = details.querySelector(":scope > .menu-drawer");
    const backdrop = details.querySelector(":scope > .menu-drawer__backdrop");
    if (!drawer || !backdrop) return;

    backdrop.classList.add("menu-drawer__backdrop--ported");
    drawer.classList.add("menu-drawer--ported");
    document.body.appendChild(backdrop);
    document.body.appendChild(drawer);

    drawer.querySelectorAll("img").forEach(function (img) {
      img.loading = "eager";
      if (typeof img.decode === "function") {
        img.decode().catch(function () {});
      }
      const src = img.currentSrc || img.src;
      if (src) img.src = src;
    });
  }

  // Registered early so it runs before theme trapFocus and allows taps
  // on the portaled drawer (which sits outside <details>).
  document.addEventListener(
    "focusin",
    function (event) {
      if (!document.documentElement.classList.contains("menu-drawer-open")) {
        return;
      }
      const t = event.target;
      if (
        t instanceof Element &&
        t.closest(".menu-drawer--ported, .menu-drawer__backdrop--ported")
      ) {
        event.stopImmediatePropagation();
      }
    },
    true,
  );

  document.addEventListener(
    "toggle",
    function (event) {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      if (!details.classList.contains("menu-drawer-container")) return;

      const header = document.getElementById("header-component");

      if (details.open) {
        document.documentElement.classList.add("menu-drawer-open");
        if (header) {
          header.dataset.stickyState = "active";
          header.removeAttribute("data-animating");
        }
        requestAnimationFrame(function () {
          portalDrawer(details);
        });
      } else {
        document.documentElement.classList.remove("menu-drawer-open");
        restoreDrawer(details);
      }
    },
    true,
  );

  document.addEventListener(
    "click",
    function (event) {
      const backdrop = event.target.closest(".menu-drawer__backdrop--ported");
      if (!backdrop) return;
      const drawerHost = document.querySelector(
        "header-drawer .menu-drawer-container",
      );
      if (drawerHost instanceof HTMLDetailsElement && drawerHost.open) {
        const headerDrawer = drawerHost.closest("header-drawer");
        if (headerDrawer && typeof headerDrawer.close === "function") {
          headerDrawer.close();
        } else {
          drawerHost.open = false;
          drawerHost.classList.remove("menu-open");
          document.documentElement.classList.remove("menu-drawer-open");
          restoreDrawer(drawerHost);
        }
      }
    },
    true,
  );
})();

/**
 * Supply-aware gallery media:
 * - New parent variants are tagged by their Shopify Supply option and media ID.
 * - Selecting 30 Day hides 90 Day variant media, and vice versa.
 */
(function () {
  var wired = false;

  function getSlideshow(gallery) {
    return (
      (gallery.refs && gallery.refs.slideshow) ||
      gallery.querySelector("slideshow-component")
    );
  }

  function refreshSlideshowRefs(slideshow) {
    if (slideshow && typeof slideshow.updatedCallback === "function") {
      slideshow.updatedCallback();
    }
  }

  function reindexVisibleControls(slideshow) {
    if (!slideshow || !slideshow.refs) return;
    var thumbnails = slideshow.refs.thumbnails || [];
    var dots = slideshow.refs.dots || [];
    var i;
    var visibleIndex = 0;
    for (i = 0; i < thumbnails.length; i++) {
      if (thumbnails[i].hidden) continue;
      thumbnails[i].setAttribute("on:click", "/select/" + visibleIndex);
      visibleIndex++;
    }
    visibleIndex = 0;
    for (i = 0; i < dots.length; i++) {
      var dotItem = dots[i].closest("li") || dots[i];
      if (dotItem.hidden) continue;
      dots[i].setAttribute("on:click", "/select/" + visibleIndex);
      visibleIndex++;
    }
  }

  function isVisibleControl(control) {
    if (!control || control.hidden) return false;
    var item = control.closest("li");
    return !item || !item.hidden;
  }

  /**
   * Slideshow indexes only visible slides, while its controls refs still include
   * controls for hidden Supply media. Keep the UI on that same visible index so
   * the active thumbnail and counter do not drift after the first slide.
   */
  function syncVisibleControlState(slideshow, selectedSlide) {
    if (!slideshow || !slideshow.refs) return;

    var visibleSlides = slideshow.slides || [];
    var visibleIndex = selectedSlide
      ? visibleSlides.indexOf(selectedSlide)
      : slideshow.current;
    if (visibleIndex < 0) visibleIndex = 0;

    [slideshow.refs.thumbnails || [], slideshow.refs.dots || []].forEach(
      function (controls) {
        var visibleControls = Array.prototype.filter.call(
          controls,
          isVisibleControl,
        );
        Array.prototype.forEach.call(controls, function (control) {
          control.setAttribute(
            "aria-selected",
            String(visibleControls.indexOf(control) === visibleIndex),
          );
        });
      },
    );

    slideshow
      .querySelectorAll(".slideshow-controls__counter")
      .forEach(function (counter) {
        var current = counter.querySelector('[ref="current"]');
        if (current) current.textContent = String(visibleIndex + 1);

        var total = counter.lastChild;
        if (total && total.nodeType === Node.TEXT_NODE) {
          total.nodeValue = String(visibleSlides.length);
        }
      });
  }

  function galleryHasSupplyMedia(gallery) {
    return !!(
      gallery &&
      gallery.querySelector(
        "[data-supply-media='30'], [data-supply-media='90']",
      )
    );
  }

  function setVisible(el, visible) {
    if (!el) return;
    if (visible) {
      el.hidden = false;
      el.removeAttribute("hidden");
      if (el.removeAttribute) el.removeAttribute("reveal");
    } else {
      el.hidden = true;
      if (el.removeAttribute) el.removeAttribute("reveal");
    }
  }

  function imageKey(value) {
    if (!value) return "";
    try {
      return new URL(
        String(value),
        window.location.href,
      ).pathname.toLowerCase();
    } catch (_error) {
      return String(value).split("?")[0].toLowerCase();
    }
  }

  function mediaImageKey(node) {
    if (!node) return "";
    var img = node.querySelector("img.product-media__image, img");
    return imageKey(img && (img.currentSrc || img.src));
  }

  function isSelectedSupplyMedia(node, selectedMediaId, selectedImageKey) {
    if (!node) return false;
    var nodeMediaId = node.getAttribute("data-media-id");
    if (selectedMediaId && nodeMediaId) return nodeMediaId === selectedMediaId;
    return !!selectedImageKey && mediaImageKey(node) === selectedImageKey;
  }

  function rememberAttribute(element, attribute, storageAttribute) {
    if (!element || element.hasAttribute(storageAttribute)) return;
    var value = element.getAttribute(attribute);
    element.setAttribute(
      storageAttribute,
      value === null ? "__missing__" : value,
    );
  }

  function restoreAttribute(element, attribute, storageAttribute) {
    if (!element || !element.hasAttribute(storageAttribute)) return;
    var value = element.getAttribute(storageAttribute);
    if (value === "__missing__") {
      element.removeAttribute(attribute);
    } else {
      element.setAttribute(attribute, value);
    }
    element.removeAttribute(storageAttribute);
  }

  function overwriteImage(image, url, useAsMaxResolution) {
    if (!image || !url) return;
    rememberAttribute(image, "src", "data-shred-original-src");
    rememberAttribute(image, "srcset", "data-shred-original-srcset");
    rememberAttribute(image, "sizes", "data-shred-original-sizes");
    rememberAttribute(image, "width", "data-shred-original-width");
    rememberAttribute(image, "height", "data-shred-original-height");
    rememberAttribute(
      image,
      "data_max_resolution",
      "data-shred-original-max-resolution",
    );
    image.src = url;
    image.removeAttribute("srcset");
    image.removeAttribute("sizes");
    image.removeAttribute("width");
    image.removeAttribute("height");
    if (
      image.classList.contains("product-media__image") &&
      useAsMaxResolution !== false
    ) {
      image.setAttribute("data_max_resolution", url);
    } else if (useAsMaxResolution === false) {
      image.removeAttribute("data_max_resolution");
    }
    image.setAttribute("data-shred-offer-image-overwrite", "");
  }

  function overwriteRatio(element, property, ratio) {
    if (!element || !ratio) return;
    var storageAttribute =
      "data-shred-original-style-" +
      property.replace(/^--/, "").replace(/[^a-z0-9-]/gi, "-");
    if (!element.hasAttribute(storageAttribute)) {
      var original = element.style.getPropertyValue(property);
      element.setAttribute(storageAttribute, original || "__missing__");
    }
    element.style.setProperty(property, String(ratio));
    element.setAttribute("data-shred-offer-ratio-overwrite", "");
  }

  function restoreOfferImageOverrides(gallery) {
    gallery
      .querySelectorAll("[data-shred-offer-image-overwrite]")
      .forEach(function (image) {
        restoreAttribute(image, "src", "data-shred-original-src");
        restoreAttribute(image, "srcset", "data-shred-original-srcset");
        restoreAttribute(image, "sizes", "data-shred-original-sizes");
        restoreAttribute(image, "width", "data-shred-original-width");
        restoreAttribute(image, "height", "data-shred-original-height");
        restoreAttribute(
          image,
          "data_max_resolution",
          "data-shred-original-max-resolution",
        );
        image.removeAttribute("data-shred-offer-image-overwrite");
      });

    gallery
      .querySelectorAll("[data-shred-offer-ratio-overwrite]")
      .forEach(function (element) {
        [
          "--media-preview-ratio",
          "--ratio",
          "--aspect-ratio",
          "--gallery-aspect-ratio",
        ].forEach(function (property) {
          var storageAttribute =
            "data-shred-original-style-" +
            property.replace(/^--/, "").replace(/[^a-z0-9-]/gi, "-");
          if (!element.hasAttribute(storageAttribute)) return;
          var original = element.getAttribute(storageAttribute);
          if (original === "__missing__") {
            element.style.removeProperty(property);
          } else {
            element.style.setProperty(property, original);
          }
          element.removeAttribute(storageAttribute);
        });
        element.removeAttribute("data-shred-offer-ratio-overwrite");
      });
  }

  function findMediaNode(nodes, mediaId) {
    if (!mediaId) return null;
    return (
      Array.prototype.find.call(nodes, function (node) {
        return node.getAttribute("data-media-id") === mediaId;
      }) || null
    );
  }

  function applyOfferImageOverride(gallery, targetSlide, detail) {
    if (!targetSlide || Number(detail.days) < 90) return;
    var galleryImage =
      gallery.dataset.shredNinetyDayOfferImage || detail.galleryOverwriteImage;
    if (!galleryImage) return;

    var thumbnailImage =
      gallery.dataset.shredNinetyDayOfferThumbnailImage ||
      detail.galleryOverwriteThumbnailImage ||
      galleryImage;
    var ratio =
      Number(
        gallery.dataset.shredNinetyDayOfferImageAspectRatio ||
          detail.galleryOverwriteImageAspectRatio,
      ) || 0;
    var slides = Array.prototype.slice.call(
      gallery.querySelectorAll("slideshow-slide"),
    );
    var targetIndex = slides.indexOf(targetSlide);
    var targetMediaId = String(
      targetSlide.getAttribute("data-media-id") || detail.mediaId || "",
    );

    overwriteImage(
      targetSlide.querySelector("img.product-media__image"),
      galleryImage,
    );
    overwriteRatio(targetSlide, "--media-preview-ratio", ratio);
    overwriteRatio(
      targetSlide.querySelector(".product-media"),
      "--ratio",
      ratio,
    );

    gallery.querySelectorAll("slideshow-controls").forEach(function (controls) {
      var thumbnails = controls.querySelectorAll(
        ".slideshow-controls__thumbnail",
      );
      if (targetIndex < 0 || !thumbnails[targetIndex]) return;
      overwriteImage(
        thumbnails[targetIndex].querySelector("img"),
        thumbnailImage,
      );
      overwriteRatio(thumbnails[targetIndex], "--aspect-ratio", ratio);
    });

    var gridItem = findMediaNode(
      gallery.querySelectorAll(".media-gallery__grid > li"),
      targetMediaId,
    );
    if (gridItem) {
      overwriteImage(
        gridItem.querySelector("img.product-media__image"),
        galleryImage,
      );
      overwriteRatio(gridItem, "--media-preview-ratio", ratio);
      overwriteRatio(
        gridItem.querySelector(".product-media"),
        "--ratio",
        ratio,
      );
    }

    var zoomItems = gallery.querySelectorAll(".dialog-zoomed-gallery > li");
    var zoomItem =
      Array.prototype.find.call(zoomItems, function (item) {
        return (
          targetMediaId &&
          item.id.indexOf("product-" + targetMediaId + "-") === 0
        );
      }) || null;
    if (zoomItem) {
      var zoomIndex = Array.prototype.indexOf.call(zoomItems, zoomItem);
      overwriteImage(
        zoomItem.querySelector("img.product-media__image"),
        galleryImage,
        false,
      );
      overwriteRatio(zoomItem, "--media-preview-ratio", ratio);
      overwriteRatio(
        zoomItem.querySelector(".product-media"),
        "--ratio",
        ratio,
      );
      var zoomThumbnails = gallery.querySelectorAll(
        ".dialog-thumbnails-list__thumbnail",
      );
      if (zoomThumbnails[zoomIndex]) {
        overwriteImage(
          zoomThumbnails[zoomIndex].querySelector("img"),
          thumbnailImage,
        );
        overwriteRatio(zoomThumbnails[zoomIndex], "--aspect-ratio", ratio);
        overwriteRatio(
          zoomThumbnails[zoomIndex],
          "--gallery-aspect-ratio",
          ratio,
        );
      }
    }
  }

  function promoteSelectedSlide(gallery, targetSlide, slides) {
    var targetIndex = slides.indexOf(targetSlide);
    if (!targetSlide || targetIndex <= 0) return;

    slides[0].before(targetSlide);

    gallery.querySelectorAll("slideshow-controls").forEach(function (controls) {
      var thumbnails = Array.prototype.slice.call(
        controls.querySelectorAll(".slideshow-controls__thumbnail"),
      );
      if (thumbnails[targetIndex] && thumbnails[0]) {
        thumbnails[0].before(thumbnails[targetIndex]);
      }

      var dots = Array.prototype.slice.call(
        controls.querySelectorAll('[ref="dots[]"]'),
      );
      var targetDotItem =
        dots[targetIndex] &&
        (dots[targetIndex].closest("li") || dots[targetIndex]);
      var firstDotItem = dots[0] && (dots[0].closest("li") || dots[0]);
      if (targetDotItem && firstDotItem) firstDotItem.before(targetDotItem);
    });
  }

  function promoteSelectedGridItem(gallery, selectedMediaId, selectedImageKey) {
    var gridItems = Array.prototype.slice.call(
      gallery.querySelectorAll(".media-gallery__grid > li"),
    );
    var targetItem = gridItems.find(function (item) {
      return isSelectedSupplyMedia(item, selectedMediaId, selectedImageKey);
    });
    if (targetItem && gridItems[0] && targetItem !== gridItems[0]) {
      gridItems[0].before(targetItem);
    }
  }

  /**
   * New parent-variant flow: every Shopify variant already represents a full
   * 30- or 90-day product. Prefer the exact selected variant media even when
   * Shopify shares that featured image across both Supply values.
   */
  function applyTaggedSupplyState(gallery, detail, shouldScroll) {
    if (!gallery || !detail) return false;

    restoreOfferImageOverrides(gallery);

    var allSlides = Array.prototype.slice.call(
      gallery.querySelectorAll("slideshow-slide"),
    );
    var taggedSlides = allSlides.filter(function (slide) {
      return slide.hasAttribute("data-supply-media");
    });
    if (!taggedSlides.length) return false;

    var desiredGroup = Number(detail.days) === 30 ? "30" : "90";
    var selectedMediaId = String(detail.mediaId || "");
    var selectedImageKey = imageKey(detail.image);
    var targetSlide =
      allSlides.find(function (slide) {
        return isSelectedSupplyMedia(slide, selectedMediaId, selectedImageKey);
      }) || null;
    var hasSelectedMedia = !!targetSlide;

    if (!targetSlide) {
      targetSlide =
        taggedSlides.find(function (slide) {
          return slide.getAttribute("data-supply-media") === desiredGroup;
        }) || null;
    }

    if (targetSlide) {
      promoteSelectedSlide(gallery, targetSlide, allSlides);
      promoteSelectedGridItem(gallery, selectedMediaId, selectedImageKey);
      allSlides = Array.prototype.slice.call(
        gallery.querySelectorAll("slideshow-slide"),
      );
    }

    allSlides.forEach(function (slide, index) {
      var group = slide.getAttribute("data-supply-media");
      if (group !== "30" && group !== "90") return;
      var isSelectedMedia = isSelectedSupplyMedia(
        slide,
        selectedMediaId,
        selectedImageKey,
      );
      var visible = hasSelectedMedia ? isSelectedMedia : group === desiredGroup;
      setVisible(slide, visible);
      if (visible && !targetSlide) targetSlide = slide;

      gallery
        .querySelectorAll("slideshow-controls")
        .forEach(function (controls) {
          var thumbnails = controls.querySelectorAll(
            ".slideshow-controls__thumbnail",
          );
          var dots = controls.querySelectorAll('[ref="dots[]"]');
          if (thumbnails[index]) setVisible(thumbnails[index], visible);
          if (dots[index])
            setVisible(dots[index].closest("li") || dots[index], visible);
        });
    });

    gallery
      .querySelectorAll(".media-gallery__grid > li[data-supply-media]")
      .forEach(function (item) {
        var group = item.getAttribute("data-supply-media");
        var isSelectedMedia = isSelectedSupplyMedia(
          item,
          selectedMediaId,
          selectedImageKey,
        );
        var visible = hasSelectedMedia
          ? isSelectedMedia
          : group === desiredGroup;
        setVisible(item, visible);
      });

    applyOfferImageOverride(gallery, targetSlide, detail);

    var slideshow = getSlideshow(gallery);
    refreshSlideshowRefs(slideshow);
    reindexVisibleControls(slideshow);

    if (!targetSlide) {
      targetSlide =
        allSlides.find(function (slide) {
          return !slide.hidden;
        }) || null;
    }
    if (slideshow && targetSlide && typeof slideshow.select === "function") {
      var targetIndex = (slideshow.slides || []).indexOf(targetSlide);
      if (targetIndex < 0) targetIndex = 0;
      syncVisibleControlState(slideshow, targetSlide);
      requestAnimationFrame(function () {
        slideshow.select(targetIndex, undefined, { animate: !!shouldScroll });
      });
    }
    return true;
  }

  function readSelectedDetail(host) {
    var st = host && host.__kbSub;
    if (!st || !st.selectedId) return null;
    var options = st.options || [];
    for (var i = 0; i < options.length; i++) {
      if (options[i].id === st.selectedId) {
        return {
          id: options[i].id,
          kind: options[i].kind,
          days: Number(options[i].days) || 0,
          title: options[i].title || "",
          mediaId:
            options[i].selectedVariant && options[i].selectedVariant.mediaId,
          image: options[i].selectedVariant && options[i].selectedVariant.image,
        };
      }
    }
    return null;
  }

  function syncHost(host, shouldScroll, detail) {
    if (!host) return false;
    var selectedDetail = detail || readSelectedDetail(host);
    if (!selectedDetail) return false;
    var scope = host.closest(".shopify-section") || document;
    var productId = host.getAttribute("data-product-id");
    var galleries = productId
      ? scope.querySelectorAll(
          'media-gallery[data-product-id="' + productId + '"]',
        )
      : scope.querySelectorAll("media-gallery");
    if (!galleries.length && productId && scope !== document) {
      galleries = document.querySelectorAll(
        'media-gallery[data-product-id="' + productId + '"]',
      );
    }
    var hasSupply = false;

    for (var i = 0; i < galleries.length; i++) {
      if (
        applyTaggedSupplyState(galleries[i], selectedDetail, !!shouldScroll)
      ) {
        hasSupply = true;
      }
    }
    return hasSupply;
  }

  function init() {
    var hosts = document.querySelectorAll(
      '[data-kb-sub-layout], [data-shred-purchase-layout], [data-purchase-supply-active="true"]',
    );
    var hasSupply = false;
    for (var i = 0; i < hosts.length; i++) {
      if (syncHost(hosts[i], false)) {
        hasSupply = true;
      }
    }
    return hasSupply;
  }

  function wire() {
    if (wired) return;
    wired = true;

    document.addEventListener("kb-sub:option-change", function (event) {
      var target = event && event.target;
      var host =
        target &&
        target.closest &&
        target.closest(
          '[data-kb-sub-layout], [data-shred-purchase-layout], [data-purchase-supply-active="true"]',
        );
      if (host) syncHost(host, true, event.detail || null);
    });

    document.addEventListener("variant:update", function () {
      requestAnimationFrame(function () {
        init();
      });
    });

    document.addEventListener("slideshow:select", function (event) {
      var slideshow = event.target;
      if (
        !slideshow ||
        !slideshow.matches ||
        !slideshow.matches("slideshow-component")
      )
        return;

      var gallery = slideshow.closest("media-gallery");
      if (!galleryHasSupplyMedia(gallery)) return;

      var selectedSlide = event.detail && event.detail.slide;

      // Drag events are dispatched before Slideshow writes its native current
      // state, unlike click/scroll events. Defer our visible-index mapping so it
      // always runs after that write and cannot be overwritten by a hidden slot.
      queueMicrotask(function () {
        syncVisibleControlState(slideshow, selectedSlide);
      });
    });
  }

  function boot(attempts) {
    var galleries = document.querySelectorAll("media-gallery");

    if (!galleries.length) {
      if (attempts > 0) {
        window.setTimeout(function () {
          boot(attempts - 1);
        }, 300);
      }
      return;
    }

    var hasSupply = false;
    for (var i = 0; i < galleries.length; i++) {
      if (galleryHasSupplyMedia(galleries[i])) {
        hasSupply = true;
        break;
      }
    }
    if (!hasSupply) return;

    if (init()) {
      wire();
    } else if (attempts > 0) {
      window.setTimeout(function () {
        boot(attempts - 1);
      }, 300);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(8);
    });
  } else {
    boot(8);
  }
})();
